import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=5d331bb1&scoped=true&"
import script from "./SuccessModal.vue?vue&type=script&lang=ts&"
export * from "./SuccessModal.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessModal.vue?vue&type=style&index=0&id=5d331bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d331bb1",
  null
  
)

export default component.exports